import { useState } from "react";

export default function TeamsTab() {
  const [members, setMembers] = useState([
    { email: "michael@talkde.io", permission: "can view", status: "Pending" },
    { email: "alan@talkde.io", permission: "can edit", status: "Accepted" },
    { email: "michael@talkde.io", permission: "can view", status: "Accepted" },
    { email: "alan@talkde.io", permission: "can edit", status: "Accepted" },
  ]);

  const [newEmail, setNewEmail] = useState("");
  const [newPermission, setNewPermission] = useState("can view");
  const [saved, setSaved] = useState(false);

  const handleAddMember = () => {
    if (newEmail.trim()) {
      setMembers([
        ...members,
        {
          email: newEmail.trim(),
          permission: newPermission,
          status: "Pending",
        },
      ]);
      setNewEmail("");
      setNewPermission("can view");
      setSaved(false);
    }
  };

  const handlePermissionChange = (index, value) => {
    const updated = [...members];
    updated[index].permission = value;
    setMembers(updated);
    setSaved(false);
  };

  const handleRemoveMember = (index) => {
    setMembers(members.filter((_, i) => i !== index));
    setSaved(false);
  };

  const handleSave = () => {
    setSaved(true);
  };

  return (
    <>
      <div className="flex flex-row gap-28 items-start flex-wrap">
        <span className="text-2xl min-w-[120px]">Teams</span>
        <div className="flex flex-col flex-1 w-full md:w-[722px]">
          {/* Invite Section */}
          <div className="flex flex-col items-start gap-[7px] w-full h-[74px] mb-6">
            <label className="text-base font-medium text-gray-700">
              Invite team members
            </label>
            <div className="flex gap-4 w-full">
              {/* Combined input + select */}
              <div className="flex flex-row items-center bg-[#F4F4F4] rounded-md w-full">
                <input
                  type="email"
                  placeholder="Invite email"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  className="bg-transparent p-2 flex-1 outline-none"
                />
                <select
                  value={newPermission}
                  onChange={(e) => setNewPermission(e.target.value)}
                  className="bg-transparent p-2 text-sm text-[#7E7E7E] outline-none  border-[#D0D0D0]"
                >
                  <option>can view</option>
                  <option>can edit</option>
                </select>
              </div>

              {/* Add button */}
              <button
                type="button"
                onClick={handleAddMember}
                className="bg-[#EAF524] text-black px-6 py-2 rounded-md"
              >
                Add
              </button>
            </div>
          </div>

          {/* Member List */}
          <ul className="space-y-4 mt-6 mb-12">
            {members.map((m, i) => (
              <li
                key={i}
                className="grid grid-cols-[auto_120px_40px_100px] items-center gap-4 pb-2"
              >
                {/* Avatar + Email */}
                <div className="flex items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                  >
                    <circle cx="12" cy="12" r="12" fill="#D9D9D9" />
                  </svg>
                  <p className="font-medium break-words text-[#7E7E7E]">
                    {m.email}
                  </p>
                </div>

                {/* Permission Dropdown */}
                <select
                  value={m.permission}
                  onChange={(e) => handlePermissionChange(i, e.target.value)}
                  className="text-[#7E7E7E] rounded-md p-1 text-sm w-full"
                >
                  <option>can view</option>
                  <option>can edit</option>
                </select>

                {/* Trash Icon */}
                <button onClick={() => handleRemoveMember(i)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                  >
                    <path
                      d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
                      fill="#7B7B7B"
                    />
                  </svg>
                </button>

                {/* Status */}
                <span
                  className={`text-sm ${
                    m.status === "Accepted"
                      ? "text-green-600 bg-[#00FF1E17] px-2 py-1 rounded"
                      : "text-[#846202] bg-[#FFBB0033] px-2 py-1 rounded"
                  }`}
                >
                  {m.status}
                </span>
              </li>
            ))}
          </ul>

          {/* Save Button */}
          <div className="flex justify-center">
            <button
              onClick={handleSave}
              className="bg-[#EAF524] text-black px-6 py-2 rounded-md w-[140px] whitespace-nowrap"
            >
              {saved ? "Changes saved" : "Save changes"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
